import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import Button from '../Button';
import ActivityIndicator from '../forms/ActivityIndicator';
import ImageRadioButtonGroup from '../forms/ImageRadioButtonGroup';
import ApartmentImage from '../../../assets/images/radio-group-images/property-types/Apartment_Building.png';
import CottageImage from '../../../assets/images/radio-group-images/property-types/Cottage_Alone.png';
import EstateImage from '../../../assets/images/radio-group-images/property-types/Estate.png';
import FreeStandingImage from '../../../assets/images/radio-group-images/property-types/Standalone_House.png';
import FarmImage from '../../../assets/images/radio-group-images/property-types/Plot_farm.png';

const PropertyTypeSelector = (props) => {
  const { visible, onClickCancel, onClickContinue, isDarkMode, onPropertyTypeChange } = props;
  const [selectedResidenceValue, setSelectedResidenceValue] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const BuildingOptions = [
    { value: 'cottage', label: 'Cottage (or other property detached from main house)', image: CottageImage },
    { value: 'apartment', label: 'Flat/Apartment', image: ApartmentImage },
    { value: 'complex', label: 'Complex/Estate', image: EstateImage },
    { value: 'farm', label: 'Farm/Plot', image: FarmImage },
    { value: 'freeStanding', label: 'Free Standing', image: FreeStandingImage },
  ];

  const handleValueChange = (value) => {
    setSelectedResidenceValue(value);
    if (onPropertyTypeChange) {
      onPropertyTypeChange(value);
    }
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    onClickContinue();
    setIsSubmitting(false);
  };


  return (
    <Popup
      className="popup-alert"
      closeOnEscape={false}
      open={visible}
      closeOnDocumentClick={false}
    >
      <div className="content-box content-box-is-padding-small content-box--is-no-margin content-box--is-confirmation-popup-wrapper">
        <h1 className="confirmation-popup-title">
          {
            'Please select the type of property you would like to add to your quote:'
          }
        </h1>
        <div className="d-flex flex-row justify-content-around align-items-center pb-2">
          <ImageRadioButtonGroup
            options={BuildingOptions}
            selectedValue={selectedResidenceValue}
            multiSelect={false}
            onChange={handleValueChange}
            isDarkMode={isDarkMode}
          />
        </div>
        <div className="confirmation-popup-button-wrapper">
          <Button
            onClick={onClickCancel}
            title={'Cancel'}
            color={'white'}
            idName={'property-type-selector-popup-cancel-button'}
          />
          {isSubmitting ? (
            <ActivityIndicator />
          ) : (
            <Button
              onClick={handleSubmit}
              title={'Continue'}
              idName={'property-type-selector-popup-continue-button'}
              disabled={!selectedResidenceValue}
            />
          )}
        </div>
      </div>
    </Popup>
  );
};

export default PropertyTypeSelector;
